import React, { Component } from "react";
import { PageHeader, ListGroup } from "react-bootstrap";
import { API } from "aws-amplify";
// import "./Contacts.css";
import "./Timeline.css";
import ContactsList from "./Contacts/ContactsList";


export default class Contacts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      didMount: false,
      searchInput: '',
      searchTerm: '',
      searchHits: '',
      searchTook: '',
      contacts: [],
    };
  }

  async componentDidMount() {
    if (this.props.isAuthenticated !== true) return;
    try {
      const contacts = await this.contacts();
      this.setState({ contacts });
    } catch (e) {
      alert(e);
    }
    this.setState({ didMount: true });
  }
  
  contacts() {
    return API.get("contacts", "/contacts");
  }

  searchContacts(searchTerm) {
    console.log('searching for user input:', searchTerm);
    return API.post("contacts", "/contacts", { body: { searchTerm }});
  }

  handleItemClick = event => {
    event.preventDefault();
    this.props.history.push(event.currentTarget.getAttribute("href"));
  }

  handleSearchInput = event => {
    this.setState({ searchInput: event.target.value });
  }

  handleClickSearch = async () => {
    const searchTerm = this.state.searchInput;
    this.setState({ 
      searchTerm,
      searchInput: '',
     });
    const searchResults = await this.searchContacts(searchTerm);
    console.log(`searchResults ${searchResults.hits} in ${searchResults.took}ms`)
    this.setState({ 
      contacts: searchResults.contacts,
      searchHits: (searchResults.hits === 1 ? `${searchResults.hits} result` : `${searchResults.hits} results` ),
      searchTook: (searchResults.took < 1000 ? "under 1 second" : (searchResults.took/1000 + " seconds"))
    });
  }

  // validateSearchTerm = (searchTerm) => { // TODO !!!
  //   if (searchTerm.length > 2) {
  //     return true;
  //   }
  //   return false;
  // }

  renderContacts() {
    return (
      <div className="contacts">
        <PageHeader>Your Contacts</PageHeader>
        <div className="eXa-container">
          {/* <div className="eXa-col m6"> */}
            <div className="eXa-col m6"></div>
              <input type="text" onChange={this.handleSearchInput} value={this.state.searchInput} />
              <button onClick={this.handleClickSearch}>Search</button>
              {this.state.searchHits ?
                ` ${this.state.searchHits} in ${this.state.searchTook} for "${this.state.searchTerm}"` : null}
          {/* </div> */}
        </div>
        <div><br></br></div>
        <ListGroup>
          <ContactsList
            contacts={this.state.contacts}
            searchTerm={this.state.searchTerm}
            didMount={this.state.didMount}
            click={this.handleItemClick}
          />
        </ListGroup>
      </div>
    );
  }

  render() {
    return (
      <div className="Home">
        {this.props.isAuthenticated ? this.renderContacts() : this.renderLander()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Contacts.js